// extracted by mini-css-extract-plugin
module.exports = {"choices":"Choice_choices__Ti3vu","main":"Choice_main__2A696","choice":"Choice_choice__Grz1f","activeChoice":"Choice_activeChoice__Eb4IK"};